import axios from 'axios';
import { queryOptions } from '@tanstack/react-query';
import { API_ENDPOINT } from '../apiEndpoints';
import { queryClient } from '../queryClient';

// GET /user-settings — one shared entry for App (InfoSidebar layout), MixVibes and
// History (saved tab), which previously each fetched it on every Home load.
// User-scoped without userId in the key; cleared on logout like ['playlists'].
export const userSettingsQuery = () =>
  queryOptions({
    queryKey: ['user-settings'],
    queryFn: async (): Promise<Record<string, any>> => (await axios.get(`${API_ENDPOINT}/user-settings`)).data,
    staleTime: Infinity, // only this client writes them; saveUserSetting keeps the cache in sync
  });

// PUT a single top-level setting (e.g. 'recentDefaultTab') and mirror it into the cache
// so other readers see it without a refetch.
export const saveUserSetting = async (settingKey: string, settingValue: unknown) => {
  queryClient.setQueryData(userSettingsQuery().queryKey, (prev) => (prev ? { ...prev, [settingKey]: settingValue } : prev));
  await axios.put(`${API_ENDPOINT}/user-settings`, { settingKey, settingValue });
};
